import { STATUS_TINT } from "../../lib/monitoring";

const LABEL = {
  new: "New",
  acknowledged: "Acknowledged",
  auto_ticketed: "Auto-ticketed",
  resolved: "Resolved",
  ignored: "Ignored",
};

export default function AlertStatusBadge({ status, className = "" }) {
  const tint = STATUS_TINT[status] || STATUS_TINT.new;
  return (
    <span
      data-testid={`alert-status-${status}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${tint} ${className}`}
    >
      {LABEL[status] || status}
    </span>
  );
}
